import React, { Component } from 'react';
import { Galleria } from 'primereact/galleria';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Slider } from 'primereact/slider';
import { Checkbox } from 'primereact/checkbox';
import { ServiceApi } from "./../../service/Api";
import axios from "axios";
import md5 from 'md5';
import { jsPDF } from "jspdf";
import moment from "moment/min/moment-with-locales";
import { ProgressSpinner } from 'primereact/progressspinner';
import { split } from 'event-stream';

let listaImgThumb = [];
let _listaImagens = [];

export class GaleriaImagens extends Component {

    constructor(props) {
        super();
        this.state = {
            splash: false,
            listaSeries: [],
            intances: [],
            listaImagensThumb: [],
            listaImagens: [],
            selectImageView: "",
            visible: false,
            autoHeigth: "auto",
            activeIndex: 0,
            _autoWidth: window.innerWidth,
            _autoHeigth: window.innerHeight,
            valueInputThumb: 1,
            brilhoImageValue: 500,
            totalImagens: 0,
            impressaoImagens: "",
            servicoDeImagem: "orthanc"
        };

        this.serviceImages = "";
        this.compare = "";
        this.iconPanel = "pi pi-window-maximize";
        this.iconTitle = "Visualizar em tela cheia";
        this.ultimaImagemArrastada = null;

        this.thumbnailTemplate = this.thumbnailTemplate.bind(this);

        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 5
            },
            {
                breakpoint: '768px',
                numVisible: 3
            },
            {
                breakpoint: '560px',
                numVisible: 1
            }
        ];

    }

    funcaoArrastarSoltarImagem() {
        let _listaImagensThumb = document.getElementById("listaImagensThumb");
        var touchPos;

        if (this.props.mobilecheck()) {

            function borderDragOverMob(ativar) {
                try {
                    const el = document.body.getElementsByClassName('p-galleria-item')[0];
                    try {
                        ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                    } catch (error) { }
                } catch (error) { console.log(error); }
            }

            _listaImagensThumb.addEventListener('touchmove', function (e) {
                touchPos = e.targetTouches[0].clientX;
                borderDragOverMob(touchPos > 250);
            }, { passive: true });

            _listaImagensThumb.addEventListener('touchend', function (e) {
                if (touchPos > 250) {
                    if (e.target.tagName === "IMG") {
                        document.getElementById(e.target.id).click();
                        borderDragOverMob(false);
                    }
                }
            });
        } else {

            function borderDragOverWeb(ativar) {
                const el = document.body.getElementsByClassName('p-galleria-item')[0];
                try {
                    ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                    el.addEventListener('dragover', function (e) {
                        e.preventDefault();
                    });
                } catch (error) { }
            }

            try {
                _listaImagensThumb.addEventListener("dragover", function (e) {
                    borderDragOverWeb(e.clientX > 170 && e.clientY < 555);
                }, { passive: true });
            } catch (ex) { }

            try {
                _listaImagensThumb.addEventListener("dragend", function (e) {
                    e.preventDefault();
                    try {
                        if (e.clientX > 170 && e.clientY < 555)
                            document.getElementById(e.target.id).click();
                    } catch (error) { }
                    borderDragOverWeb(false);
                });
            } catch (ex) { }

        }
    }

    thumbMouseMove() {

        const el = document.body.getElementsByClassName('p-galleria-item')[0];

        function borderDragOverWeb(ativar) {
            try {
                try {
                    ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                } catch (error) { }
            } catch (error) { }
        }

        try {
            const slider = document.querySelector('.itemsThumb');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', (e) => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 3; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });

            //Arrastar/soltar imagem...                    
            el.addEventListener("dragover", function (e) {
                e.preventDefault();
                borderDragOverWeb(e.clientX > 200 && e.clientY < 570);
            });

            slider.addEventListener("dragend", function (e) {
                e.preventDefault();
                if (e.clientX > 200 && e.clientY < 570)
                    document.getElementById(e.target.id).click();
                borderDragOverWeb(false);
            });
        }
        catch (error) { console.log(error); }

        if (this.props.mobilecheck()) {
            let touchPos = { StartX: 0, EndX: 0, StartY: 0, EndY: 0 };
            el.addEventListener('touchmove', function (e) {
                if (touchPos.StartX === 0 && touchPos.StartY === 0) {
                    touchPos.StartX = e.targetTouches[0].clientX;
                    touchPos.StartY = e.targetTouches[0].clientY;
                }
                touchPos.EndX = e.targetTouches[0].clientX;
                touchPos.EndY = e.targetTouches[0].clientY;
            }, { passive: true });
            el.addEventListener('touchend', function (e) {
                if (touchPos.StartX > 0 && touchPos.EndX > 0) {
                    if (touchPos.EndY < (touchPos.StartY * 2) && touchPos.EndY > (touchPos.StartY / 2))
                        touchPos.StartX > touchPos.EndX ? window.nextImageTouch() : window.prevImageTouch();
                    touchPos = { StartX: 0, EndX: 0, StartY: 0, EndY: 0 }
                }
            });
        }
    }

    checkServicoDeImagem() {
        const servicoImagem = this.props.servicoImagem;
        try {
            if (servicoImagem.split("/studies").length > 1) {
                return this.setState({
                    servicoDeImagem: "asl.dicom"
                })
            }
        } catch (error) { }
    }

    componentDidMount() {

        this.checkServicoDeImagem();

        document.getElementById("progressSpinner").style.display = "flex";

        document.body.style.overflow = "hidden";
        window.addEventListener("resize", this.atualizarWidthHeigth, false);
        setTimeout(() => {
            this.funcaoArrastarSoltarImagem();
        }, 1000);
        window.prevImageTouch = () => { this.prevImageTouch() };
        window.nextImageTouch = () => { this.nextImageTouch() };

        // window.addEventListener("hashchange", function (e) {            
        //     if(this.props.panelImageJpegVisible){
        //         let _urlAtiva = urlAtiva.replace('medico','portal');
        //         //if (e.newURL !== _urlAtiva)
        //             window.location.href = _urlAtiva;
        //     }
        // });
    }

    prevImageTouch() {
        let _activeIndex = this.state.activeIndex > 0 ? this.state.activeIndex - 1 : 0;
        this.setState({
            activeIndex: _activeIndex,
            valueInputThumb: _activeIndex + 1
        });
    }
    nextImageTouch() {
        let _activeIndex = this.state.activeIndex + 1 < this.state.listaImagens.length ? this.state.activeIndex + 1 : this.state.activeIndex;
        this.setState({
            activeIndex: _activeIndex,
            valueInputThumb: _activeIndex + 1
        });
    }

    atualizarWidthHeigth = (event) => {
        this.setState({
            _autoHeigth: event.target.innerHeight,
            _autoWidth: event.target.innerWidth,
        })
        setTimeout(() => {
            this.funcaoArrastarSoltarImagem();
        }, 1000);
    }

    componentWillUnmount() {
        document.body.style.overflow = "auto";
    }

    componentDidUpdate() {
        this.init();
    }

    init() {
        if (this.props.selectedPedido) {
            let _compare = btoa(this.props.selectedPedido.Series);
            if (this.compare !== _compare) {
                this.setState({
                    listaImagensThumb: [],
                    listaImagens: [],
                    selectImageView: ""
                });
                this.listarSeries();
                this.compare = _compare;
            }
        }
    }

    selecionaPrimeiraImagem() {
        try {
            setTimeout(() => {
                document.getElementById("img0").click();
                document.getElementById("progressSpinner").style.display = "none";
            }, 2000);
        } catch (error) { }
    }

    async getValuesServiceSerie(servicoImagem, studyUid) {
        let seriesAslDicom = [];
        await axios.get(`${servicoImagem}/${studyUid}/getstudyimagens`)
            .then(res => {
                res.data.instanceImage.forEach(obj => {
                    seriesAslDicom.push({
                        Serie: obj.serie,
                        Instances: obj.instances
                    });
                });
                this.adicionaImagensAListaAslDicom(seriesAslDicom);
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    }

    adicionaImagensAListaAslDicom(seriesAslDicom) {
        listaImgThumb = [];
        let order = 0;
        try {
            if (seriesAslDicom.length > 0) {

                seriesAslDicom.forEach(obj => {
                    let urlImage = `${this.props.servicoImagem}/${this.props.selectedPedido.StudyUid}/series/${obj.Serie}/instances/${obj.Instances[0]}/frames/0/rendered/512/512`;
                    order++;
                    this.loadFileSerie(urlImage, obj, order);
                });

                const tm = setInterval(() => {
                    if (order === listaImgThumb.length) {
                        clearInterval(tm);
                        const listaImgThumbOrdenada = listaImgThumb.sort((a, b) => {
                            if (a.order < b.order)
                                return -1;
                            if (a.order > b.order)
                                return 1;
                            return 0;
                        });

                        this.setState({
                            listaImagensThumb: listaImgThumbOrdenada,
                            selectImageView: listaImgThumbOrdenada[0].label,
                        });

                        this.selecionaPrimeiraImagem();
                    }
                }, 200);

            }
        } catch (error) {
            console.log(error);
        }

    }

    listarSeriesServicoAsl() {
        this.getValuesServiceSerie(this.props.servicoImagem, this.props.selectedPedido.StudyUid)
    }

    listarSeriesServicoOrthanc() {
        try {
            if (this.props.selectedPedido) {
                let series = JSON.parse(this.props.selectedPedido.Series);
                series.forEach(el => {
                    let url = this.props.servicoImagem + "/series/" + el.Id;
                    return ServiceApi.getImages(url)
                        .then(res => {
                            this.adicionaImagensALista(res.Instances);
                        });
                });
            }
        } catch (error) { console.log(error); }
        this.selecionaPrimeiraImagem();
    }

    adicionaImagensALista(instances) {
        let urlImage = this.props.servicoImagem + "/instances/" + instances[0] + "/rendered?height=512";
        this.loadFileSerie(urlImage, instances);
    }

    listarSeries() {
        if (this.state.servicoDeImagem === "asl.dicom")
            return this.listarSeriesServicoAsl();
        return this.listarSeriesServicoOrthanc();
    }

    loadFileSerie(urlImage, instances, order) {
        document.getElementById("progressSpinner").style.display = "flex";
        axios.get(urlImage, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'image/jpeg',
                'height': '512',
                'smooth': true
            }
        }).then(response => {
            const _blob = new Blob([response.data], { type: 'image/jpeg' });
            listaImgThumb.push({ label: URL.createObjectURL(_blob), instances: instances, order: order });
        });
    }

    loadFileGaleria(urlImage, order) {
        document.getElementById("progressSpinner").style.display = "flex";
        axios.get(urlImage, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'image/jpeg',
                'height': '512',
                'smooth': true
            }
        }).then(response => {
            const _blob = new Blob([response.data], { type: 'image/jpeg' });
            _listaImagens = this.state.listaImagens;
            _listaImagens.push({ label: URL.createObjectURL(_blob), order: order });
            this.setState({
                listaImagens: _listaImagens,
                selectImageView: _listaImagens[0].label,
            });
        });
    }

    listarImagensPorSerie(instances) {

        this.setState({ listaImagens: [], activeIndex: 0, valueInputThumb: 1 });

        let order = 0;

        if (this.state.servicoDeImagem === "orthanc") {
            instances.forEach(el => {
                let urlImage = this.props.servicoImagem + "/instances/" + el + "/rendered?height=400";
                this.loadFileGaleria(urlImage, 0);
            });
            this.state.totalImagens = instances.length;
        } else {
            instances.Instances.forEach(el => {
                let urlImage = `${this.props.servicoImagem}/${this.props.selectedPedido.StudyUid}/series/${instances.Serie}/instances/${el}/frames/0/rendered/512/512`;
                order++;
                this.loadFileGaleria(urlImage, order);
            });
            this.state.totalImagens = instances.Instances.length;

            //Ordenar imagens
            const tm = setInterval(() => {
                if (order === _listaImagens.length) {
                    clearInterval(tm);
                    const listaImgOrdenada = _listaImagens.sort((a, b) => {
                        if (a.order < b.order)
                            return -1;
                        if (a.order > b.order)
                            return 1;
                        return 0;
                    });

                    this.setState({
                        listaImagens: listaImgOrdenada,
                        selectImageView: listaImgOrdenada[0].label,
                    });
                }
            }, 500);

        }

        setTimeout(() => {
            this.thumbMouseMove();
            document.getElementById("progressSpinner").style.display = "none";
        }, 1000);

    }

    calcBrilhoImagem() {
        if (this.state.brilhoImageValue === 500)
            return this.state.brilhoImageValue / 5;
        if (this.state.brilhoImageValue < 500)
            return this.state.brilhoImageValue < 300 ? this.state.brilhoImageValue / 2 : this.state.brilhoImageValue / 3;
        if (this.state.brilhoImageValue > 500)
            return this.state.brilhoImageValue > 700 ? this.state.brilhoImageValue / 2 : this.state.brilhoImageValue / 3;
    }

    itemTemplate(item, width) {
        try {
            let image = item ? item : this.state.listaImagens[0];
            return <div> <img src={image.label} id={`imgView${this.state.activeIndex}`} style={{
                height: this.props.mobilecheck() ? window.innerWidth <= 640 ? '200px' : '230px' : `${(window.innerHeight - 250)}px`,
                filter: `brightness(${this.state.brilhoImageValue > 500 ? this.state.brilhoImageValue > 700 ? this.state.brilhoImageValue : this.state.brilhoImageValue / 3 : this.state.brilhoImageValue / 5}%)`,
                display: 'block'
            }} />
                <div style={{
                    color: '#666',
                    textAlign: 'right',
                    position: 'absolute',
                    width: '97%',
                    left: '0',
                    bottom: '12px',
                    fontSize: '12px'
                }}>
                    Imagem: {this.state.valueInputThumb} de {this.state.totalImagens}
                </div>
            </div>;
        } catch (error) {
            console.log(error);
        }
    }

    thumbnailTemplate(item) {
        return <img src={item.label} id={md5(item.label)} style={{ display: 'block' }} height="40" />;
    }

    onItemChange(event) {
        this.setState({ activeIndex: event.index, valueInputThumb: event.index + 1 });
    }
    onItemChangeThumb(index) {
        this.setState({ activeIndex: index, valueInputThumb: index + 1 });
        /*/
        if (focusThumb) {
            setTimeout(() => {
                try {
                    const _itemsThumb = document.querySelector('.itemsThumb');
                    const _imgThumbSel = document.querySelector('.imgThumbSel');
                    _itemsThumb.scrollLeft = _imgThumbSel.offsetLeft - 10;
                } catch (error) { }
            }, 500);
        }
        /*/
    }

    handleKeyPress = (e) => {
        if (e.key == 'Enter') {
            this.onItemChangeThumb(e.target.value - 1)
        }
    }

    renderFooter() {
        return (

            <div>
                <div id="listaImagensThumb" className="itemsThumb scrollbarColorThumb" style={{ display: this.state._autoHeigth < 400 ? 'none' : 'block' }}>
                    {
                        this.state.listaImagens.map((srcImg, index) => {
                            return <img
                                src={srcImg.label}
                                width="70"
                                onClick={() => this.onItemChangeThumb(index)}
                                className="imgThumbSerie"
                                id={`imgThumb${index}`}
                                style={{ marginRight: '10px' }}
                                className={this.state.activeIndex === index ? 'imgThumbSel' : ''}
                            />
                        })
                    }
                </div>

                <div className="custom-galleria-footer">
                    <div>
                        <Button
                            icon="pi pi-chevron-left"
                            className="p-button-rounded p-button-text"
                            style={{ marginRight: '5px', top: '4px' }}
                            onClick={() => this.onItemChangeThumb(this.state.activeIndex > 0 ? this.state.activeIndex - 1 : 0)}
                        />
                        <input value={this.state.valueInputThumb} onKeyPress={(e) => this.handleKeyPress(e, true)} onChange={(e) => this.setState({ valueInputThumb: e.target.value })}
                            type="text" className="numImage"
                        />
                        <Button
                            icon="pi pi-chevron-right"
                            className="p-button-rounded p-button-text"
                            style={{ marginLeft: '5px', top: '4px' }}
                            onClick={() => this.onItemChangeThumb(this.state.activeIndex < this.state.listaImagens.length - 1 ? this.state.activeIndex + 1 : this.state.activeIndex)}
                        />
                    </div>

                    <div>
                        <div style={{ marginBottom: '12px', textAlign: 'center' }}>
                            <label style={{ fontSize: '12px' }}>Brilho da imagem ({`${(this.state.brilhoImageValue / 10)}%`})</label>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '20px auto 20px', color: '#999', columnGap: '10px' }}>
                            <span style={{ textAlign: 'center', marginTop: '-7px' }}>-</span>
                            <Slider style={{ with: '100%' }} value={this.state.brilhoImageValue} step={10} max={1000} onChange={(e) => this.setState({ brilhoImageValue: e.value })} />
                            <span style={{ textAlign: 'center', marginTop: '-7px' }}>+</span>
                        </div>
                    </div>

                </div>

            </div>

        );
    }

    adicionaImagemAoLayout(obj) {
        if (obj.Index < this.state.listaImagens.length)
            try {
                return obj.Pdf.addImage(this.state.listaImagens[obj.Index].label, 'jpg', obj.X, obj.Y, 96, 80);
            } catch (error) { }
        return "";
    }

    imprimirImagens() {
        let totalPaginas = Math.ceil(this.state.listaImagens.length / 6);
        let _index = 0;
        const doc = new jsPDF();
        doc.setFontSize(9);
        for (let indexPagina = 0; indexPagina < totalPaginas; indexPagina++) {
            if (indexPagina > 0)
                doc.addPage();
            doc.text(`PACIENTE: ${this.props.selectedPedido.Paciente.Nome}`, 10, 10);
            doc.text(`DATA: ${moment(this.props.selectedPedido.DataEstudo).format("DD/MM/YYYY")}`, 10, 15);
            this.adicionaImagemAoLayout({ Index: _index + indexPagina, Pdf: doc, X: 10, Y: 22 });
            this.adicionaImagemAoLayout({ Index: _index + indexPagina + 1, Pdf: doc, X: 107, Y: 22 });
            this.adicionaImagemAoLayout({ Index: _index + indexPagina + 2, Pdf: doc, X: 10, Y: 103 });
            this.adicionaImagemAoLayout({ Index: _index + indexPagina + 3, Pdf: doc, X: 107, Y: 103 });
            this.adicionaImagemAoLayout({ Index: _index + indexPagina + 4, Pdf: doc, X: 10, Y: 184 });
            this.adicionaImagemAoLayout({ Index: _index + indexPagina + 5, Pdf: doc, X: 107, Y: 184 });
            doc.text('Essas imagens são ilustrativas e não servem para realização do diagnóstico.', 10, 285);
            doc.text('A qualidade da imagem dependerá da impressora utilizada.', 10, 290);
            doc.text('© 2021 Tzion MyResult 2022.002.01.36', 145, 290);
            _index = _index + 5;
        }
        if (this.props.mobilecheck()) {
            doc.save(`MyResult-Exame-${this.props.selectedPedido.Id}.pdf`);
        } else {
            var winPrint = window.open(doc.output('bloburl'));
            winPrint.document.title = 'Tzion MyResult - Impressão de Imagens';
            setTimeout(() => {
                winPrint.document.close();
                winPrint.print();
            }, 1000);
        }
        this.props.adicionarHistoricoAcoes(42, this.props.selectedPedido.Id);
    }

    render() {

        const footer = this.renderFooter();

        return (

            <div>

                <div id="progressSpinner" style={{ display: 'none', alignItems: 'center', position: 'absolute', width: `100%`, height: `${this.state._autoHeigth}px`, background: '#000', zIndex: '100000', opacity: '0.8' }}>
                    <ProgressSpinner />
                    <Button label="Cancelar" style={{ left: '0', bottom: '0', width: '100%', position: 'absolute' }} onClick={() => this.props.onHideGaleria()} />
                </div>

                <div style={{ padding: "10px", position: "fixed", color: "#2196f3", marginTop: '7px' }}>{`Tzion MyResult ${this.state._autoWidth > 400 ? '- Galeria de Imagens' : ''}`}</div>

                <Button disabled={this.state.listaImagens.length === 0} title="Imprimir imagens" label="Salvar/Imprimir" icon="pi pi-print" className="p-button-rounded p-button-secondary p-button-outlined" onClick={() => { this.imprimirImagens() }} style={{ display: this.props.selectedPedido.Unidade.ImprimirImagemPortal ? 'block' : 'none', position: "absolute", zIndex: "99999", right: '50px', top: '5px' }} />

                <Button title="Fechar galeria de imagens" icon="pi pi-times" className="p-button-rounded p-button-secondary p-button-outlined" onClick={() => { this.props.onHideGaleria() }} style={{ position: "absolute", zIndex: "99999", right: '5px', top: '5px' }} />

                <div style={{ display: "grid", gridTemplateColumns: `${this.state._autoWidth < 540 ? '0' : '180'}px auto`, position: "absolute", marginTop: "50px" }}>

                    <div id="listaImagensThumb" className="scrollbarColor" style={{ display: this.state._autoWidth < 540 ? "none" : "block", overflow: "auto", paddingTop: "20px", borderRight: "solid 1px cadetBlue", borderTop: 'solid 1px cadetblue', width: this.state._autoWidth > 540 ? '180px' : '', height: `${(this.state._autoHeigth - 45)}px` }}>
                        {
                            this.state.listaImagensThumb.map((srcImg, index) => {
                                // return <img src={srcImg.label}  style={{width:"80%",cursor:"pointer"}} onClick={(e) =>   window.open(srcImg.label, '_new')}/>
                                return <img
                                    src={srcImg.label}
                                    width="150"
                                    style={{ borderBottom: 'solid 20px #000', paddingLeft: "20px", cursor: "pointer" }}
                                    onClick={() => this.listarImagensPorSerie(srcImg.instances)}
                                    className="imgThumbSerie"
                                    draggable={true}
                                    id={`img${index}`}
                                />
                            })
                        }

                    </div>

                    <div id="galleria" style={{ width: this.state._autoWidth }}>

                        <Galleria
                            showItemNavigators={this.props.mobilecheck() === false}
                            value={this.state.listaImagens}
                            activeIndex={this.state.activeIndex}
                            responsiveOptions={this.responsiveOptions}
                            style={{ width: this.state._autoWidth > 540 ? (this.state._autoWidth - 180) : 'auto', borderTop: 'solid 1px cadetblue' }}
                            item={(e) => this.itemTemplate(e, this.state._autoWidth)}
                            //numVisible={5} circular
                            //showThumbnailNavigators={this.state._autoWidth > 750}
                            //thumbnail={this.state._autoWidth > 750 ? this.thumbnailTemplate : ''}
                            //showItemNavigatorsOnHover={this.state._autoWidth < 750}
                            //showThumbnails={this.state._autoWidth > 750}
                            showThumbnails={false}
                            // footer={this.state._autoHeigth > 450 ? footer : null}
                            footer={footer}
                            onItemChange={(e) => this.onItemChange(e)}
                        />

                        <div className="infoOrientacaoCel" style={{ display: this.state._autoWidth < 540 ? "block" : "none" }}>Mude a orientação do seu celular para exibir a lista de séries.</div>


                    </div>

                </div>

                <div id="impressaoImagens" style={{ position: 'absolute', left: '-2000px' }}>{this.state.impressaoImagens}</div>

            </div>

        )

    }
}